import React, { useState } from 'react'
import unionBy from 'lodash/unionBy'
import { getClassGene, getPossibleSummonClasses } from '../../helpers/genes.helpers'
import { getSummoningProbability, sortAndFilterHeroes } from './functions'
import MatchMakerPage from '../../components/MatchMakerPage'

const statusMessages = [
    'Now there is an interesting fellow.',
    'Oh, the Tavern has Perch Porter on draft.',
    'Chatting with Agent Selina.  She is such a sweetheart!',
    'Are those wings on her back, or she just harpy to see me?',
    'Woah, big guy!  Careful with those horns!',
]

const defaultFilters = {
    classMatch: false,
    includeSummonClass: false,
    maxGen: 14,
    maxTotalCost: '',
    maxSummons: '',
    minGen: 0,
    minProbability: '',
    professionMatch: false,
    subclassMatch: false,
    summonsRemaining: '',
    traitFocus: 'all',
}

const MatchMakerContainer = () => {
    const [cardView, setCardView] = useState('back')
    const [filters, setFilters] = useState(defaultFilters)
    const [hasLoaded, setHasLoaded] = useState(false)
    const [highlights, setHighlights] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [isWallet, setIsWallet] = useState(false)
    const [loadingMessage, setLoadingMessage] = useState('')
    const [mainHero, setMainHero] = useState()
    const [matches, setMatches] = useState([])
    const [sortBy, setSortBy] = useState('probability')
    const [summoningEnabled, setSummoningEnabled] = useState(false)

    const delay = ms => new Promise(res => setTimeout(res, ms))

    // Updates filters
    const handleFilterChange = filter => {
        setFilters(f => ({ ...f, [filter.key]: filter.value }))
    }

    // Sets the main hero
    const handleMainHeroChange = hero => {
        setMainHero(hero)
        setMatches([])
    }

    // Displays the Summoning page
    const handleMatchSelected = hero => {
        console.log('redirect to the summoning page')
    }

    // Creates a new search for the specified search criteria
    const handleSearch = async searchCriteria => {
        setMatches([])
        setIsLoading(true)
        setRandomLoadingMessage()

        let allHeroes = []
        const pageSize = 50
        let offset = 0
        let isLastPage = false

        setIsWallet(searchCriteria.searchWallets.length > 0)
        setSummoningEnabled(mainHero.network === searchCriteria.network)

        // Set the highlights
        const classes = getPossibleSummonClasses(mainHero.mainClass, searchCriteria.summonClass)
        const subclasses =
            searchCriteria.summonSubclass === 'all'
                ? []
                : getPossibleSummonClasses(mainHero.subClass, searchCriteria.summonSubclass)
        setHighlights({ mainClass: classes, subClass: subclasses, profession: [searchCriteria.summonProfession] })

        // Retrieve a page of hero listings from tavern
        const options = {
            auctionType: searchCriteria.auctionType,
            network: searchCriteria.network,
            mainClasses: classes.map(c => getClassGene(c)),
            subClasses: subclasses.map(c => getClassGene(c)),
            summonClass: searchCriteria.summonClass,
            summonSubclass: searchCriteria.summonSubclass,
            profession: searchCriteria.summonProfession,
            wallets: searchCriteria.searchWallets,
        }

        while (!isLastPage) {
            const [filteredHeroes, listedHeroesCount] = await getSummoningProbability(
                mainHero,
                options,
                pageSize,
                offset
            )

            console.log(`${allHeroes.length} existing heroes`)
            console.log(`adding ${filteredHeroes.length} new heroes`)

            // Merge and sort heroes by highest to lowest probability of summoning target class
            allHeroes = unionBy(allHeroes, filteredHeroes, 'id')

            console.log(`now ${allHeroes.length} total heroes`)

            // Update state to display heroes
            setMatches(allHeroes)
            setRandomLoadingMessage()

            offset += pageSize
            isLastPage = listedHeroesCount === 0

            await delay(1000)

            // ONLY LOAD 1 PAGE FOR TESTING
            // isLastPage = offset > 50
        }

        setIsLoading(false)
        setHasLoaded(true)
    }

    // Updates sorting options
    const handleSortByChange = value => {
        setSortBy(value)
    }

    // Change the current view
    const handleViewToggled = checked => {
        setCardView(checked ? 'front' : 'back')
    }

    // Update the message that is displayed while tavern data is being loaded
    const setRandomLoadingMessage = () => {
        const randomIndex = Math.floor(Math.random() * statusMessages.length)
        setLoadingMessage(statusMessages[randomIndex])
    }

    const sortedHeroes = mainHero ? sortAndFilterHeroes(matches, filters, sortBy, mainHero.mutationClass) : []

    return (
        <MatchMakerPage
            cardView={cardView}
            filters={filters}
            hasLoaded={hasLoaded}
            heroCount={matches.length}
            heroes={sortedHeroes}
            highlights={highlights}
            isLoading={isLoading}
            isWallet={isWallet}
            loadingMessage={loadingMessage}
            mainHero={mainHero}
            onFilterChange={handleFilterChange}
            onMatchSelected={handleMatchSelected}
            onSelectedHeroChange={handleMainHeroChange}
            onSearch={handleSearch}
            onSortByChange={handleSortByChange}
            onViewToggled={handleViewToggled}
            summoningEnabled={summoningEnabled}
        />
    )
}

export default MatchMakerContainer
